import { render, staticRenderFns } from "./UserAgreement.vue?vue&type=template&id=de8a3698&scoped=true&"
import script from "./UserAgreement.vue?vue&type=script&lang=js&"
export * from "./UserAgreement.vue?vue&type=script&lang=js&"
import style0 from "./UserAgreement.vue?vue&type=style&index=0&id=de8a3698&prod&lang=less&scoped=true&"
import style1 from "./UserAgreement.vue?vue&type=style&index=1&id=de8a3698&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de8a3698",
  null
  
)

export default component.exports